import { useQueryUser } from '@heidi/workspace/data';

import { useQueryComplimentaryUsage } from '../../../data/query/useQueryComplimentaryUsage';
import { useQueryCreditAllowance } from '../../../data/query/useQueryCreditAllowance';
import { getTrialEndUsagePercent } from './classify-trial-end-usage';

/**
 * Usage share for the ended modal's analytics, read from the same queries the
 * eligibility check already loaded. Mount only while the modal is open.
 */
export function useComplimentaryTrialEndedUsagePercent(): number | null {
  const { data: user } = useQueryUser();
  const { data: usage } = useQueryComplimentaryUsage({ hasUser: !!user });
  const { data: allowance } = useQueryCreditAllowance({ hasUser: !!user });
  if (usage?.consumed == null || allowance?.display_limit == null) return null;
  return getTrialEndUsagePercent({
    consumed: usage.consumed,
    displayLimit: allowance.display_limit,
  });
}
